import { Formik } from 'formik';
import React, { useCallback, useState } from 'react';
import { Button, ListGroup, Modal } from 'react-bootstrap';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { SelectorInput } from '../../components/Form/SelectorInput';
import { SubmitButton } from '../../components/Form/SubmitButton';
import { GroupSelector } from './components/GroupSelector';

interface RegistrationScreenProps {}

interface RegistrationFormValues {
    group: number;
    universityDegree: string;
}

export const RegistrationScreen: React.FC<RegistrationScreenProps> = ({}) => {
    const [visible, setVisible] = useState(true);

    const close = useCallback(() => {
        setVisible(false);
    }, []);

    const show = useCallback(() => {
        setVisible(true);
    }, []);

    const history = useHistory();
    const isStudent = false;

    const initialValues: RegistrationFormValues = {
        group: 0,
        universityDegree: 'test',
    };

    return (
        <Modal show={visible} onHide={close} backdrop="static" keyboard={false} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Завершіть реєстрацію</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={initialValues}
                    onSubmit={async (form) => {
                        console.log(form);
                        return;
                        history.replace('/');
                    }}
                >
                    <div>
                        <div>
                            <GroupSelector isStudent={isStudent} />
                        </div>
                        {!isStudent && <div>Ваша посада:</div>}
                        {/* <SelectorInput name="universityDegree" kseys={[{ key: 'test', value: 'Test' }]} /> */}
                        <SelectorInput />
                        <SubmitButton style={{ marginBottom: 40 }}>Зберегти</SubmitButton>
                    </div>
                </Formik>
            </Modal.Body>
        </Modal>
    );
};
